"use strict";
'use es6'; // eslint-disable-next-line no-unused-vars

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uint32;

function uint32(props, propName, componentName, location) {
  var value = props[propName];

  if (value !== value >>> 0) {
    return new Error("Invalid prop `" + propName + "` supplied to " + componentName + ", expected " + ("a uint32, received `" + value + "`"));
  }

  return null;
}

module.exports = exports.default;